import { Modal } from '@convergence/components';
import { faBug } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

export function AssumeRole() {
  const [modalVisible, setModalVisible] = useState(false);
  const [userId, setUserId] = useState('');
  return (
    <>
      <button className="text-lime-500" onClick={() => setModalVisible(true)}>
        <FontAwesomeIcon icon={faBug} size="xs" />
      </button>
      <Modal visible={modalVisible} onClose={() => setModalVisible(false)}>
        <input
          className="text-lime-500"
          type="text"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
        <button
          onClick={async () => {
            await fetch('https://api.convergence.dev/auth/assume-user', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              credentials: 'include',
              body: JSON.stringify({
                userId
              })
            });
          }}
        >
          Assume Role
        </button>
      </Modal>
    </>
  );
}
